module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Blood_on_the_Tracks2#Contents-A"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Introduction copyright © 2018 Martin Edwards")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Published by Poisoned Pen Press in association with the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Edition 2018"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("First US Trade Paperback Edition")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Catalog Card Number: 2018930056")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 9781464209697           Trade Paperback"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("           9781464209703           Ebook")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("‘The Eighth Lamp’ reproduced with permission of Curtis Brown Group Ltd, London, on behalf of the Estate of William Edward Vickers.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "char-style-override"
  }, [_vm._v("‘The Unsolved Puzzle of the Man with No Face’ from ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Peter Views the Body")]), _c('span', {
    staticClass: "char-style-override"
  }, [_vm._v(", published by Hodder & Stoughton and reproduced by permission of David Higham Associates on behalf of Dorothy L. Sayers.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("‘The Level Crossing’ reproduced by permission of The Society of Authors as the Literary Representative of the Estate of Freeman Wills Crofts.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("‘The Adventure of the First-Class Carriage’ reproduced by permission of United Agents LLP on behalf of Lady Magdalen Howard.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("‘Murder on the 7.16’ reproduced with permission of Peters Fraser & Dunlop Ltd on behalf of Michael Innes Literary Management Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("‘The Coulman Handicap’ reproduced with permission of Curtis Brown Group Ltd, London on behalf of The Beneficiaries of the Literary Estate of Michael Gilbert. Copyright © Michael Gilbert, 1958.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior written permission of both the copyright owner and the publisher of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The historical characters and events portrayed in this book are inventions of the author or used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "char-style-override"
  }, [_vm._v("Poisoned Pen Press"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("4014 N. Goldwater Boulevard, #201"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Scottsdale, Arizona 85251")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "http://www.poisonedpenpress.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("www.poisonedpenpress.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('a', {
    staticClass: "calibre1",
    attrs: {
      "href": "mailto:info%40poisonedpenpress.com?subject="
    }
  }, [_c('span', {
    staticClass: "hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("info@poisonedpenpress.com")])]), _c('span', {
    staticClass: "hyperlink",
    attrs: {
      "xml:lang": "en-US"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54f36c8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Blood_on_the_Tracks-1.vue
// module id = 63
// module chunks = 0